import { Badge, Table } from "@chakra-ui/react";
import { AssessmentType } from "../../../../services/Dtos";
import { useSchoolsContext } from "../../../../Contexts/schoolContext";
import SettingsCard from "../../../CustomUi/SettingsCard";

interface Props {
  assessmentType: AssessmentType;
  handleClick: () => void;
}

export default function AssessmentTypeCard({
  assessmentType,
  handleClick,
}: Props) {
  const { levels, school, accentColor } = useSchoolsContext();

  return (
    <SettingsCard minW={"270px"} handleClick={handleClick}>
      <Table.Root fontSize={"sm"} variant={"outline"}>
        <Table.Body>
          <Table.Row>
            <Table.Cell>Short Name</Table.Cell>
            <Table.Cell textAlign={"right"} fontWeight={"bold"} pl={5}>
              <Badge
                variant={"outline"}
                colorPalette={school?.accentColor || accentColor}
                size={"md"}
              >
                {assessmentType.shortName}
              </Badge>
            </Table.Cell>
          </Table.Row>

          <Table.Row>
            <Table.Cell>Full Name</Table.Cell>
            <Table.Cell textAlign={"right"} fontWeight={"bold"} pl={5}>
              {assessmentType.name}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Max Score</Table.Cell>
            <Table.Cell textAlign={"right"} fontWeight={"bold"} pl={5}>
              {assessmentType.maxScore}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Level</Table.Cell>
            <Table.Cell textAlign={"right"} fontWeight={"bold"} pl={5}>
              {levels.find((l) => l.id === assessmentType.levelId)?.levelName}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Order</Table.Cell>
            <Table.Cell textAlign={"right"} fontWeight={"bold"} pl={5}>
              {assessmentType.order}
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table.Root>
    </SettingsCard>
  );
}
